import React, { useState, useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip,
  Divider,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  Switch,
  CircularProgress
} from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import "./displayqueues.css";
import EditQueuesPage from "../Editing/editQueues/editqueue";
import AddQueuesPage from "../Adding/addQueues/addqueues";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";

const QueuesPage = ({
  data = [],
  onDeleteQueue,
}) => {
  const [queues, setQueues] = useState(data);
    const [actionClicked, setActionClicked] = useState(null); 
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingQueue, setEditingQueue] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemsToDelete, setItemsToDelete] = useState([]);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [copiedArn, setCopiedArn] = useState(null);
  const [togglingStatus, setTogglingStatus] = useState({}); // Track which queues are being toggled
 const username = localStorage.getItem("username")
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
  const email = localStorage.getItem("Email");
const [loading, setLoading] = useState(false);
  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    setCopiedArn(value);
    setTimeout(() => setCopiedArn(null), 2000);
  };

  const filteredQueues = useMemo(() => {
    if (!searchQuery.trim()) return queues;

    const lowerSearch = searchQuery.toLowerCase();

    return queues.filter((q) => {
      const nameMatch = q.name?.toLowerCase().includes(lowerSearch);
      const descMatch = q.description?.toLowerCase().includes(lowerSearch);
      const statusMatch = q.status?.toLowerCase().includes(lowerSearch);
      const tagsMatch = Array.isArray(q.tags)
        ? q.tags.some((tag) => tag.toLowerCase().includes(lowerSearch))
        : q.tags?.toLowerCase().includes(lowerSearch);
      const arnMatch = q.arn?.toLowerCase().includes(lowerSearch);

      return nameMatch || descMatch || statusMatch || tagsMatch || arnMatch;
    });
  }, [queues, searchQuery]);

  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  // Handle status toggle
  const handleStatusToggle = async (queueIndex, currentStatus) => {
    const queue = queues[queueIndex];
    const newStatus = currentStatus === "ENABLED" ? "DISABLED" : "ENABLED";
    
    // Set loading state for this specific queue
    setTogglingStatus(prev => ({ ...prev, [queueIndex]: true }));

    try {
      const requestPayload = {
        action: "UpdateQueueStatus", // You might need to adjust this based on your API
        ID: EncryptedInstanceId,
        QueueName: queue.name,
        QueueId: queue.id, // Include queue ID if available
        QueueStatus: newStatus,
        InstanceAlias: instanceAlias,
        Email: email,
        UserName:username, // You might want to get this dynamically
        region,
        awsAccount: customerAWSAccountId,
      };

      const response = await axiosInstance.post(
        endpoints.addQueue.addqueues, // You might need a different endpoint for status updates
        requestPayload
      );

      if (response.status === 200) {
        // Update the queue status in local state
        const updatedQueues = [...queues];
        updatedQueues[queueIndex] = {
          ...updatedQueues[queueIndex],
          status: newStatus
        };
        setQueues(updatedQueues);
        
        console.log(`Queue ${queue.name} status changed to ${newStatus}`);
      } else {
        throw new Error("Failed to update queue status");
      }
    } catch (error) {
      console.error("Failed to toggle queue status:", error);
      // You might want to show a toast notification here
      alert(`Failed to ${newStatus.toLowerCase()} queue: ${error.message}`);
    } finally {
      // Remove loading state
      setTogglingStatus(prev => {
        const newState = { ...prev };
        delete newState[queueIndex];
        return newState;
      });
    }
  };

//   const handleDeleteClick = (index) => {
//     setItemsToDelete([queues[index]]);
//     setDeleteIndex(index);
//     setDeleteDialogOpen(true);
//   };
// const [loading, setLoading] = useState(false);

//   const handleConfirmDelete = async () => {
//     setLoading(true);
//     try {
//       const requestPayload = {
//         action: "Delete",
//         ID: EncryptedInstanceId,
//         QueueName: itemsToDelete[0]?.name,
//         InstanceAlias: instanceAlias,
//         ConfirmDeletion: false,
//         Email: email,
//         UserName:username,
//         region,
//         awsAccount: customerAWSAccountId,
//       };

//       const response = await axiosInstance.post(
//         endpoints.addQueue.addqueues,
//         requestPayload
//       );

//       if (response.status === 200) {
//         const updated = queues.filter((_, i) => i !== deleteIndex);
//         setQueues(updated);
//         setDeleteDialogOpen(false);
//         setItemsToDelete([]);
//         if (onDeleteQueue) {
//           onDeleteQueue(deleteIndex);
//         }
//       }
//     } catch (error) {
//       console.error("Failed to delete queue:", error);
//     }
//      setLoading(false);
//   };
const [deletingQueueName, setDeletingQueueName] = useState(null); // track which row is deleting

const handleDeleteClick = (index) => {
    setItemsToDelete([queues[index]]);
    setDeleteIndex(index);
    setDeleteDialogOpen(true);
  };
const handleConfirmDelete = async () => {
  const queueName = itemsToDelete[0]?.name;
  setDeletingQueueName(queueName); // mark row as deleting

  try {
    const requestPayload = {
      action: "Delete",
      ID: EncryptedInstanceId,
      QueueName: queueName,
      InstanceAlias: instanceAlias,
      ConfirmDeletion: false,
      Email: email,
      UserName: username,
      region,
      awsAccount: customerAWSAccountId,
    };

    const response = await axiosInstance.post(
      endpoints.addQueue.addqueues,
      requestPayload
    );

    if (response.status === 200) {
      const updated = queues.filter((_, i) => i !== deleteIndex);
      setQueues(updated);
      setDeleteDialogOpen(false);
      setItemsToDelete([]);
      if (onDeleteQueue) {
        onDeleteQueue(deleteIndex);
      }
    }
  } catch (error) {
    console.error("Failed to delete queue:", error);
  }

  setDeletingQueueName(null); // reset after done
};

  const handleQueueAdded = (updatedlist) => {
    setQueues(updatedlist || []);
    setShowAddForm(false);
  };

  const handleQueueUpdated = (updatedList) => {
    console.log("Updated list received in QueuesPage:", updatedList);
    setQueues(updatedList || []);
    setEditingQueue(null);
  };

  if (showAddForm) {
    return (
      <AddQueuesPage
        onClose={() => setShowAddForm(false)}
        onProfileAdded={handleQueueAdded}
        instanceAlias={instanceAlias}
        instanceId={instanceId}
        customerAWSAccountId={customerAWSAccountId}
        region={region}
      />
    );
  }

  if (editingQueue) {
    return (
      <EditQueuesPage
        queue={editingQueue}
        onClose={() => setEditingQueue(null)}
        onUpdate={handleQueueUpdated}
      />
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h6"className="phone-number-title" >
        Amazon Connect Queues list
      </Typography>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={1} gap={2}>
      <TextField
  className="search-textfield"
  placeholder="Search by name or description..."
  value={searchQuery}
  onChange={handleSearchChange}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <SearchIcon />
      </InputAdornment>
    ),
  }}
/>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          className="addqueue-button"
          onClick={() => setShowAddForm(true)}
        >
          Add Queue
        </Button>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Paper elevation={3}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Tags</TableCell>
              <TableCell>Arn</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>Last Modified Time</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredQueues.map((queue, index) => {
              // Find the original index in the unfiltered array for proper state management
              const originalIndex = queues.findIndex(q => q.arn === queue.arn);
              const isToggling = togglingStatus[originalIndex];
              const isEnabled = queue.status === "ENABLED";
               const isDeleting = deletingQueueName === queue.name;
              return (
                <TableRow key={queue.arn || index}>
                  <TableCell>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setEditingQueue(queue);
                      }}
                      style={{
                        textDecoration: "underline",
                        color: "#1976d2",
                        cursor: "pointer",
                      }}
                    >
                      {queue.name}
                    </a>
                  </TableCell>

                  <TableCell>{queue.description || "-"}</TableCell>

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* <Chip
                        label={queue.status || "UNKNOWN"}
                        color={isEnabled ? "success" : "default"}
                        size="small"
                      /> */}
                      
                      {/* Toggle Switch */}
                      <Box display="flex" alignItems="center" gap={1}>
                        {isToggling ? (
                          <CircularProgress size={20} />
                        ) : (
                          <Tooltip title={`${isEnabled ? 'Disable' : 'Enable'} queue`}>
                            <Switch
                              checked={isEnabled}
                              onChange={() => handleStatusToggle(originalIndex, queue.status)}
                              size="small"
                              color="primary"
                              disabled={isToggling}
                            />
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell>
                    {Array.isArray(queue.tags)
                      ? queue.tags.join(", ")
                      : queue.tags || "-"}
                  </TableCell>

                  <TableCell>
                    <Tooltip title={copiedArn === queue.arn ? "Copied" : "Copy ARN"}>
                      <IconButton onClick={() => handleCopy(queue.arn)}>
                        <ContentCopyOutlinedIcon
                          color={copiedArn === queue.arn ? "primary" : "inherit"}
                          fontSize="small"
                        />
                      </IconButton>
                    </Tooltip>
                  </TableCell>

                 <TableCell align="center">
  {/* <IconButton
    color="error"
    onClick={() => handleDeleteClick(originalIndex)}
    disabled={deletingQueueName === queues[originalIndex]?.name}
  >
    {deletingQueueName === queues[originalIndex]?.name ? (
      <CircularProgress size={18} />
    ) : (
      <DeleteIcon />
    )}
  </IconButton> */}
   <IconButton
                      color="error"
                      onClick={() => handleDeleteClick(originalIndex)}
                      disabled={isDeleting}
                    >
                      {isDeleting ? (
                        <CircularProgress size={18} />
                      ) : (
                        <DeleteIcon />
                      )}
                    </IconButton>
</TableCell>
<TableCell>{queue.lastModifiedTime}</TableCell>

                </TableRow>
              );
            })}

            {filteredQueues.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography color="textSecondary">
                    No matching queues found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

  
<Dialog
  open={deleteDialogOpen}
  onClose={() => {
    setDeleteDialogOpen(false);
    setActionClicked(null); // reset on close
  }}
>
  <DialogTitle>Confirm Deletion</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to delete the selected queue?
    </DialogContentText>
  </DialogContent>

  <DialogActions>
  
    <Button
    
      onClick={() => {
        setActionClicked("no");
        setDeleteDialogOpen(false); // just close
      }}
   variant="outlined"
         color="inherit"
         disabled={actionClicked !== null && actionClicked !== "no"}
         sx={{
           opacity: actionClicked === "yes" ? 0.3 : 1,
           minWidth: "80px",
           "&.Mui-disabled": {
             backgroundColor: "#f5f5f5",
             color: "#999",
             borderColor: "#ddd"
           }
         }}
       >
         {actionClicked === "no" ? <CircularProgress size={18} /> : "No"}
       </Button>

    {/* Yes Button */}
    <Button
      color="error"
      variant="contained"
      onClick={async () => {
        setActionClicked("yes");
        await handleConfirmDelete(); // call your delete function
        setDeleteDialogOpen(false);
        setActionClicked(null); // reset for next use
      }}
     disabled={actionClicked !== null && actionClicked !== "yes"}
          startIcon={
            actionClicked === "yes" ? <CircularProgress size={18} color="inherit" /> : null
          }
          sx={{
            opacity: actionClicked === "yes" ? 0.7 : 1,
            minWidth: "120px",
            "&.Mui-disabled": {
              backgroundColor: "#ffebee",
              color: "#f44336"
            }
          }}
        >
          {actionClicked === "yes" ? "Deleting..." : "Yes, Delete"}
        </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default QueuesPage;